export default __webpack_public_path__ + "207c55353198ccb043f63d3b7e03ffda.png";